export default __webpack_public_path__ + "static/beacon-order-e09fa130b398157d690df960f3ad5682.webm";